const APP_TYPE_COURT_RENTAL = 6;
export const ENABLE_TAG_DONE_OCCUPATION = 97;
export const ENABLE_COLOR_BY_TAG_OCCUPATION = 98;
let appType = null;

export function setAppType(newAppType) {
  appType = newAppType;
}

export function getAppType() {
  return appType;
}

export function isAppTypeCourtRental() {
  return APP_TYPE_COURT_RENTAL === appType;
}
